// // guard-request-info
import SideMenu from '@/containers/side-menu/SideMenu.vue';
import GuardRequest from '@/pages/guard/guard-request/GuardRequest.vue';

export default {
  path: '/guard-request-info',
  name: 'GuardRequest',
  components: {
    mainContent: GuardRequest,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'guard-request-info',
    },
    breadcrumb: {
      title: 'Guarda municipal',
      paths: [{ title: 'Gerenciamento' }],
    },
  },
};
